import Vue from "vue"
import utils from "@/builder/utils.js"
import Validations from '@/api/ElementValidations'

/**
 * Recibe un componente de un formulario y, si tiene validaciones, las ejecuta.
 * Tambien valida sus nodos hijo.
 */

let me = {
  api: null
}

me.setClientAPI = (c) => { me.api = c }

me.clearValidationErrors = () => {
  // me.api.forceUpdate()
  me.api.commit("clearValidationErrors")
}

me.validateElem = (element, rootElement) => {
  if (!rootElement) rootElement = element;
  let ctx = me.api.getContext()
  ctx.validationErrors.length = 0;
  let errores = me.getValidationErrors(element, rootElement)

  if (errores) {
    Vue.set(ctx, "validationErrors", errores);
  }

  return errores;
}
/**
 * Devuelve una lista de errores de validacion de un componente de un formulario.
 */
 me.getValidationErrors = (element, rootElement) => {
  let validationErrors = []
  if (!element) return validationErrors;
  if (!element.children && !element.validations) return validationErrors;

  // los elementos ocultos no disparan errores de validacion.
  const vue_elem = window.api.getComponent(element)
  if (!vue_elem && element.propsData?.isHidden) {
    console.log('no bindable: element.propsData?.isHidden', element.propsData?.isHidden)
    // eval('debugger')
    const k  = window.api.getComponent(element)
    console.log('k', k)
    // esto no esta 100% bien. si hay un componente con isHidden: "() => this.getParent(2).coleccion?.length" y "instance_name": "() => this.getParent(2).name + '_table'"
    // entonces vue_elem estara vacio, y no sabemos que componente se corresponde con this, por lo que no podemos evaluar la funcion.
    // pendiente de implementar, por ahora los sub-componentes se validaran aunque esten ocultos.
  }

  if (vue_elem) {
    // si el elemento esta oculto no se valida.
    if (window.api.eval(element.propsData?.isHidden, vue_elem)) return validationErrors;
  }

  window._.each(element.validations, v => {
    let fun = Validations[v.key];

    if (!fun || !utils.isFunction(fun)) return;


    // Si el elemento tiene un atributo targetObject, quiere decir que no se coloca en
    // formData[name], sino en (fn ()targeOject).name. Esto es una convencion para
    // poder crear editar objetos compuestoss (__('tercero').nombre) directamente
    // desde elementos del formulario.

    // Si el elemento tiene un atributo target, se aplica __(target) como valor a validar

    let valueToValidate = window.__(element.propsData?.target || element.name)
    // eval('debugger')
    const target = window.api.eval(element.propsData?.targetObject, window.api.getVueElementForNode( element ))
    if (target) {
      valueToValidate = target[element.name]
    }

    // window.console.log('Validando>', element.label, valueToValidate, v.key)
    let hayError = fun(valueToValidate, v.params || {})
    // window.console.log('resultado validacion>', hayError)
    let pageIndex = me.api.getContext().currentPage
    let cname = (element.propsData ||{}).label || element.name
    if (hayError) {
      validationErrors.push({
        element: element,
        validation: v,
        offendingValue: valueToValidate,
        msg: 'Error en el campo ' + cname,
        description: hayError,
        pageIndex: pageIndex,
        pageLabel: (me.api.getPages()[pageIndex] || {}).text
      })
    }
  });

  const children = element?.children || []
  // eval('debugger')
  // const children = get_children(rootElement)
  if (!children.length) return validationErrors;
  window._.each(children, n => {
    // let erroresHijos = me.getValidationErrors(n, null)
    let erroresHijos = me.getValidationErrors(n, rootElement)
    if (erroresHijos && erroresHijos.length) {
      validationErrors = validationErrors.concat(erroresHijos)
    }
  });

  return validationErrors;
}
/*
const get_children = comp => {
  if (!comp?.$children) return []

  const direct = comp?.$children
  const indirect = []
  window._.each(direct, d => {
    const o = get_children(d)
    indirect.push(o)
  })

  return window._.flatMap([...direct, ...indirect])
}
*/
me.isRequired = (element) => {
  let node = (element||{}).node
  // window.console.log('isreq', node)
  if (!node || !node.validations) return false;

  if (!Array.isArray(node.validations)) return node.validations === 'required' || node.validations === 'minLength';

  let r = false;
  window._.forEach(node.validations, v => {
    r = r || v.key === 'required' || v === 'required' || v.key === 'minLength' || v === 'minLength'
  })

  if (node.isRequired !== undefined) r = r || node.isRequired()

  return r;
}

/**
 * Element puede ser el dom element o el nombre del elemento, indistintamente.
 * @param {*} element
 * @returns
 */
me.hasErrors = (element) => {
  let ve = me.validationErrorsForElement(element) || []
  return ve.length ? ve[0] : {}
}
/**
 * Element puede ser el dom element o el nombre del elemento, indistintamente.
 * @param {*} element
 * @returns
 */
me.validationErrorsForElement = (e) => {
  let elementName = (e['name']) ? e.name : e
  let ve = (me.api.getContext().validationErrors || [])
  let errs = window._.filter(ve, (err) => {
      return (err.element || {}).name === elementName
  })
  return errs
}


export default me;
